import axios from "axios";
import {
  GET_DEVICES,
  GET_DEVICES_FAILED,
  GET_DEVICES_SUCCESS,
} from "../types/DevicesTypes";

function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export const getDevicesMotion = () => (dispatch) => {
  var config = {
    method: "GET",
    url: "/api/tracking/devices",
    headers: {},
  };
  dispatch({
    type: GET_DEVICES,
    payload: "LOADING",
  });
  axios(config)
    .then(function (response) {
      dispatch({
        type: GET_DEVICES_SUCCESS,
        payload: response.data.result,
      });
    })
    .catch(function (error) {
      deleteAllCookies();
      dispatch({
        type: GET_DEVICES_FAILED,
        payload: error,
      });
    });
};
